// links
export const GITHUB_URL = "https://github.com/SOunit/portfolio";
export const LINKEDIN_URL = "https://www.linkedin.com/in/sho-okawa-1249a6222/";
